import { emailMsg, fieldCantBeEmptyMsg, invalidValueMsg, t } from '../../i18n/index.js';
import { EMAIL_REGEX } from '../../utils/emailUtils.js';
import { InputComponent } from '../components/InputComponent.js';
import type { OptionalInputComponentProps } from '../components/InputComponent.js';

export interface EmailProps extends OptionalInputComponentProps {
  errorText?: string;
}

export const Email = (props: EmailProps) => {
  const {
    name = 'email',
    label = t.ZVQ5(emailMsg),
    placeholder = t.ZVQ5(emailMsg),
    required = true,
    disabled = false,
    hint,
    readonly,
    errorText = t.DUPA(invalidValueMsg),
  } = props;
  const validate = (value: string) => {
    if (!value) {
      if (required) {
        return t.VPVR(fieldCantBeEmptyMsg);
      }
    } else if (!EMAIL_REGEX.test(value)) {
      return errorText;
    }
    return undefined;
  };
  return (
    <InputComponent
      validate={validate}
      name={name}
      type="text"
      label={label}
      placeholder={placeholder}
      disabled={disabled}
      required={required}
      hint={hint}
      readonly={readonly}
      {...props}
    />
  );
};
